import { isDev } from './domain-dependency.service';

const host = window.location.hostname;

export enum Features {
    STORYBOOK = 'STORYBOOK',
    SOCIAL_JANUARY = 'SOCIAL_JANUARY', // Teď už to je pouze MailRecords
    SUGGESTION = 'SUGGESTION', // Podnety + ...
    TANGIBLE_DEPOSITS = 'TANGIBLE_DEPOSITS', // Hmotná depozita
    PROVIDED_OPERATIONS_REPORTS = 'PROVIDED_OPERATIONS_REPORTS', // Výkazy poskytovaných činností
    WAREHOUSE_MATERIAL = 'WAREHOUSE_MATERIAL',
    SERVICE_ANNOUNCEMENT = 'SERVICE_ANNOUNCEMENT',
    PURO = 'PURO',
    OFFLINE_MODE = 'OFFLINE_MODE',
    GUIDE = 'GUIDE',
    SOCIAL_FOLDER_DASHBOARD = 'SOCIAL_FOLDER_DASHBOARD', // nastenka klienta - nove widgety
    SOCIAL_SERVICE_DASHBOARD = 'SOCIAL_SERVICE_DASHBOARD', // nastenka sluzby - nove nastaveni widgetu
    SOCIAL_PAYMENTS_AND_BILLING = 'SOCIAL_PAYMENTS_AND_BILLING', // Vyúčtování pro sociální služby
    USER_MESSAGES = 'USER_MESSAGES', // Zprávy uživatelům + Metodické zprávy
    SOCIAL_PROJECTS = 'SOCIAL_PROJECTS',
    SOCIAL_FINANCIAL_DEPOSIT = 'SOCIAL_FINANCIAL_DEPOSIT',
    SOCIAL_STATISTICS = 'SOCIAL_STATISTICS',
    NEW_CALENDAR = 'NEW_CALENDAR',
    // Při aktivaci zaregistrovat v příslušných postgres.config.ts a úspěšně provést obě migrace:
    // user-management (DB user_management): HealthcareCalendarPermissions1792713600000.
    // services (DB services): HealthcareCalendarData1792368000001.
    // Flag zpřístupnit až po dokončení obou migrací, bez souběžných zápisů starého kalendáře.
    HEALTHCARE_CALENDAR_MIGRATION = 'HEALTHCARE_CALENDAR_MIGRATION',
    FOLDER_MULTI_PERSON = 'FOLDER_MULTI_PERSON', // více osob ve složce (folder_person)
    SERVICE_CENTER_MANAGER = 'SERVICE_CENTER_MANAGER',
    PARENT_ORGANIZATION = 'PARENT_ORGANIZATION',
    EXTENDED_WORK_EXPORTS = 'EXTENDED_WORK_EXPORTS',
    E_POUKAZ = 'E_POUKAZ',
    ATTENDANCE = 'ATTENDANCE',
    NURSING_ALLOWANCE = 'NURSING_ALLOWANCE', // Krátkodobé i dlouhodobé eOšetřovné
    TRASH = 'TRASH',
    ARCHIVE_DISPOSAL = 'ARCHIVE_DISPOSAL',
    DATABOXES = 'DATABOXES',
    EMAIL_CLIENT = 'EMAIL_CLIENT',

    // Hotfix pro skrytí, bo práva dostali všichni manageři/správci
    DESKA_MONITOR = 'DESKA_MONITOR',
    E_PRESCRIPTION_MAGISTRALITER = 'E_PRESCRIPTION_MAGISTRALITER',
    SOCIAL_CREDITS = 'SOCIAL_CREDITS',
    EREFERRALS = 'EREFERRALS',
}

// To toggle features ON everywhere without removing conditions
const allowFeaturesInProd: Features[] = [
    Features.OFFLINE_MODE,
    Features.PURO,
    Features.PROVIDED_OPERATIONS_REPORTS,
    Features.SOCIAL_PROJECTS,
    Features.SUGGESTION,
    Features.TANGIBLE_DEPOSITS,
    Features.WAREHOUSE_MATERIAL,
    Features.SERVICE_ANNOUNCEMENT,
    Features.SOCIAL_FOLDER_DASHBOARD,
    Features.SOCIAL_PAYMENTS_AND_BILLING,
    Features.SOCIAL_STATISTICS,
    Features.GUIDE,
];

// To toggle features ON for specific domains
const allowFeaturesInHosts: Record<string, Features[]> = {};

// To toggle features OFF for specific domains
const forbidFeaturesInHosts: Record<string, Features[]> = {
    'localhost': [Features.OFFLINE_MODE],
    '127.0.0.1': [Features.OFFLINE_MODE],
};

export function featureCheck(feature: Features): boolean {
    return (
            isDev
            || allowFeaturesInProd.includes(feature)
            || allowFeaturesInHosts[host]?.includes(feature)
        )
        && !forbidFeaturesInHosts[host]?.includes(feature)
        ;
}

export const featureOn = Object.values(Features).reduce((acc, value) => {
    acc[value] = featureCheck(value);
    return acc;
}, {} as Record<Features, boolean>);
